import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardContent, Stack, Switch, Typography } from "@mui/material";
import { cardTitleSx } from "../../theme";
import { setCorrectY, setCorrectZ } from "../../reducer/RawSurfaceSlice";

/**
 * Surface Correction panel for the Raw Surface tab - mirrors Scan Analysis's own
 * SurfaceCorrectionCard.js exactly (CorrectY/CorrectZ are the whole of what's tunable here, per
 * Common/Data/SurfaceCorrection.cs having no other knobs), but wired to RawSurfaceSlice's
 * live-update convention: a toggle dispatches its own setter and immediately recomputes, no
 * separate Apply step.
 */
export default function RawSurfaceCorrectionCard({ commit }) {
    const rawSurface = useSelector((state) => state.rawSurface);
    const dispatch = useDispatch();

    return (
        <Card>
            <CardContent>
                <Typography sx={cardTitleSx}>Surface Correction</Typography>
                <Typography variant="caption" color="text.secondary">
                    Removes the calibration bar's own known bow from each axis, before the filters
                    below run.
                </Typography>

                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1.5 }}>
                    <Typography variant="body2">Correct Y</Typography>
                    <Switch
                        size="small"
                        checked={rawSurface.correctY}
                        onChange={(e) => {
                            dispatch(setCorrectY({ correctY: e.target.checked }));
                            commit();
                        }}
                    />
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Typography variant="body2">Correct Z</Typography>
                    <Switch
                        size="small"
                        checked={rawSurface.correctZ}
                        onChange={(e) => {
                            dispatch(setCorrectZ({ correctZ: e.target.checked }));
                            commit();
                        }}
                    />
                </Stack>
            </CardContent>
        </Card>
    );
}
